import { https } from "../http";
import { showError } from "../utils/index";
import { showSkaiTokenError } from "../utils/skaiErrors";

// Separate, standalone endpoint — not related to note.js's generateAiNote/
// generateBothAiNotes. Only fields the frontend actually has are included in
// the payload; anything it doesn't have (e.g. clientResponse, progress,
// carePlanOutcome) is simply omitted rather than guessed — handled backend-side.
const generateQuickNoteAi = async (payload) => {
  try {
    const response = await https().post("/note/ai-response/quick-note", payload);
    return response?.data;
  } catch (error) {
    // A spent token balance comes back as 403 "Token quota exceeded" — showing
    // that raw under "Oops! Something went wrong" doesn't tell the user what to
    // do about it.
    if (!showSkaiTokenError(error)) {
      showError(error?.response?.data?.message, error?.response?.status);
    }
    return null;
  }
};

export { generateQuickNoteAi };
